/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from rtu-ui-v2/schemas/common/UserGuidanceConfiguration.yaml
import { BackgroundStyle, IconStyle, StyledText } from './Common';
/**
Configuration of the hint guiding users through the scanning process.
*/
export class UserGuidanceConfiguration {
    /** @param source {@displayType `DeepPartial<UserGuidanceConfiguration>`} */
    constructor(source = {}) {
        /**
          Determines whether the user guidance is visible or not.
          
          Default is true
          */
        this.visible = true;
        /**
          The title of the user guidance.
          */
        this.title = new StyledText({ color: '?sbColorOnPrimary' });
        /**
          The background style used for the user guidance.
          */
        this.background = new BackgroundStyle({
            strokeColor: '#00000000',
            fillColor: '?sbColorSurfaceLow',
        });
        if (source.visible !== undefined) {
            this.visible = source.visible;
        }
        if (source.title !== undefined) {
            this.title = new StyledText(source.title);
        }
        if (source.background !== undefined) {
            this.background = new BackgroundStyle(source.background);
        }
    }
}
/**
Configuration of the hint (containing an icon) guiding users through the scanning process.
*/
export class IconUserGuidanceConfiguration {
    /** @param source {@displayType `DeepPartial<IconUserGuidanceConfiguration>`} */
    constructor(source = {}) {
        /**
          Determines whether the user guidance is visible or not.
          
          Default is true
          */
        this.visible = true;
        /**
          Configuration of the icon appearance.
          */
        this.icon = new IconStyle({ color: '?sbColorOnPrimary' });
        /**
          The title of the user guidance.
          */
        this.title = new StyledText({ color: '?sbColorOnPrimary' });
        /**
          Configuration of the background appearance for the user guidance hints.
          */
        this.background = new BackgroundStyle({ fillColor: '?sbColorSurfaceLow' });
        if (source.visible !== undefined) {
            this.visible = source.visible;
        }
        if (source.icon !== undefined) {
            this.icon = new IconStyle(source.icon);
        }
        if (source.title !== undefined) {
            this.title = new StyledText(source.title);
        }
        if (source.background !== undefined) {
            this.background = new BackgroundStyle(source.background);
        }
    }
}
//# sourceMappingURL=UserGuidanceConfiguration.js.map